module.exports = __webpack_public_path__ + "static/media/1200px-Telegram_2019_Logo.svg.f2fc46dd.webp";